import config from '@/utils/config'
import armsRum from '@arms/rum-browser'
if(['pretest','production'].includes(config.env) && config.isBuild){
    armsRum.init({
        endpoint: 'https://proj-xtrace-5d3bc8173a1ae451a2ecff164f4c021-cn-hangzhou.cn-hangzhou.log.aliyuncs.com/rum/web/v2?workspace=default-cms-1717109352005813-cn-hangzhou&service_id=gwnx59qg1h@51a4403492e1f09903e87',
        // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
        env: config.env,
        // 设置路由模式， 参考值：'history' | 'hash'
        spaMode: 'history',
        collectors: {
            // 页面性能指标监听开关，默认开启
            perf: true,
            // WebVitals指标监听开关，默认开启
            webVitals: true,
            // Ajax监听开关，默认开启
            api: true,
            // 静态资源开关，默认开启
            staticResource: true,
            // JS错误监听开关，默认开启
            jsError: true,
            // 控制台错误监听开关，默认开启
            consoleError: true,
            // 用户行为监听开关，默认开启
            action: true,
        },
        // 链路追踪配置开关，默认关闭
        tracing: false,
    });
}

// 设置ARMS用户ID
export const setArmsUser = (userId) => {
  try {
    // 覆盖设置
    if(['pretest','production'].includes(config.env) && config.isBuild){
      const config = armsRum.getConfig();
      armsRum.setConfig({
        ...config,
        user: {
          name: userId,
        }
      })
    }
    
  } catch (e) {}
}

export default armsRum;
